export default "__VITE_ASSET__BxsyT_4D__"